// sticky element should have ref="sticky" and :style="style"
// can take activatePercentsFromTop as prop/data

export default {

    data() {
        return {
            parentPosition: {
                top: 0,
                bottom: 0
            },
            ownHeight: 0,
            translateStyleString: `translateY(${0}px)`,
            activateBackup: 0
        }
    },

    computed: {

        currentScroll() {
            return this.$store.state.globals.currentScroll
        },
        
        screenHeight() {
            return this.$store.state.globals.screenHeight
        },

        smoothScrollbarInstance() {
            return this.$store.state.settings.smoothScrollbarInstance
        },

        offsetPercentInPixels() {
            return this.screenHeight * ((this.activatePercentsFromTop || 0) / 100)
        },

        style() {
            return !this.smoothScrollbarInstance ? {
                    top: `${this.activatePercentsFromTop || 0}vh`,
                    position: 'sticky',
                } : // for when smooth scrollbar isn't active
                {
                    transform: this.translateStyleString
                }
        }
    },

    watch: {
        currentScroll(scroll) {
            if (!this.smoothScrollbarInstance) {
                return;
            }
            
            // is active (moving)
            if (
                scroll > this.parentPosition.top &&
                scroll < this.parentPosition.bottom
            ) {
                this.setTranslateAmountTo(scroll - this.parentPosition.top)
            }

            // we're above (place el in top of container)
            if (scroll < this.parentPosition.top) {
                this.setTranslateAmountTo(0);
            }

            // we're below (place el in bottom of container)
            if (scroll > this.parentPosition.bottom - this.ownHeight) {
                this.setTranslateAmountTo(this.parentPosition.height - this.ownHeight);
            }

            this.calcOffsetFromTop(); // a bit non-performant
        }
    },

    methods: {
        setTranslateAmountTo(amount) {
            this.translateStyleString = `translateY(${amount}px)`;
        },
        calcOffsetFromTop() {
            this.parentPosition = {
                top: this.$refs.sticky.parentElement.getBoundingClientRect().top +
                    this.currentScroll -
                    this.offsetPercentInPixels,
                bottom: this.$refs.sticky.parentElement.getBoundingClientRect().bottom +
                    this.currentScroll -
                    this.offsetPercentInPixels,
                height: this.$refs.sticky.parentElement.getBoundingClientRect().height
            };
        }
    },

    mounted() {
        this.calcOffsetFromTop()
        this.ownHeight = this.$refs.sticky.getBoundingClientRect().height
    }
}